import i18n from '../../../i18n';

export const BUSINESS = 'business';
export const CONSUMER = 'consumer';

const names = {
    [BUSINESS]: 'booking.customer_type_business',
    [CONSUMER]: 'booking.customer_type_consumer',
};

export const selectOptions = [
    {
        value: BUSINESS,
        label: serviceName(BUSINESS)
    },
    {
        value: CONSUMER,
        label: serviceName(CONSUMER)
    }
];


export function serviceName(type) {
    return i18n.t(names[type]);
}
